import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';
import { fetchPageFeedScheduled, getPageScheduledFeed, fetchFeedScheduled, getScheduledFeed } from 'mewe/fetchers/fetch-feed';

export default Route.extend({
  leaf: true,

  pageId() {
    return this.modelFor('app.publicid').page?.id;
  },

  id() {
    return this.modelFor('app.publicid').uuid;
  },

  beforeModel(transition) {
    if (this.pageId()) {
      this.set('theme', Theme.PAGE);
      const { to: toRouteInfo } = transition;
      const id = this.pageId();
      const pageModel = this.modelFor('app.publicid').page;

      if (!pageModel.get('isOwnerAdmin')) {
        window.location.href = '/404';
        return;
      }

      fetchPageFeedScheduled(id, { hashtag: toRouteInfo.queryParams.tag });
    } else {
      this.set('theme', Theme.PROFILE);
      fetchFeedScheduled(this.id(), { limit: 5 });
    }
  },

  model() {
    if (this.pageId()) {
      return {
        app: this.modelFor('app'),
        page: this.modelFor('app.publicid').page,
        feed: getPageScheduledFeed(this.pageId()),
      };
    } else {
      return {
        app: this.modelFor('app'),
        feed: getScheduledFeed(this.id()),
      };
    }
  },

  actions: {
    refreshFeed() {
      this.refresh();
    },
  },
});
